import type { TooltipProps } from '.'

import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import styles from './tooltip.module.css'

export function Tooltip({
  align,
  children,
  content,
  open,
  defaultOpen,
  onOpenChange,
  side,
  ...props
}: Omit<TooltipProps, 'className' | 'customContent'> & {
  content: React.ReactNode
}) {
  return (
    <TooltipPrimitive.Provider
      // Time before showing tooltip on initial hover:
      delayDuration={125} // Reduced from default (700ms)
      // Shorter delay when moving between multiple tooltip triggers:
      // Creates a more fluid experience when exploring tooltipped elements
      skipDelayDuration={25} // Reduced from default (300ms)
    >
      <TooltipPrimitive.Root
        open={open}
        defaultOpen={defaultOpen}
        onOpenChange={onOpenChange}
      >
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            align={align}
            {...props}
            className={`${styles['tooltip-content']} z-50`}
          >
            {content}
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}
